import React from "react";
import { Box, Typography, Avatar, Grid, Stack } from "@mui/material";
import { Phone, Email, LocationOn } from "@mui/icons-material";

const Resume34 = ({
  color = "#2d3436", // Intha color tha ippo headers-kku apply aagum
  font = "Inter, Roboto, sans-serif",
  fontSize = "13px",
  headingSize = "18px",
  pageSize = "A4",
}) => {
  // Section Header with Dynamic Background Color
  const SectionHeader = ({ title }) => (
    <Box sx={{ 
      bgcolor: color, // Header background color ippo dynamic-a maarum
      py: 1, 
      px: 2, 
      mb: 3, 
      textAlign: "center",
      borderRadius: "4px"
    }}>
      <Typography sx={{ 
        fontWeight: "bold", 
        letterSpacing: 2, 
        color: "#fff", // Text-a white-a mathiruken visibility-kaga
        fontSize: headingSize,
        textTransform: "uppercase"
      }}>
        {title}
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ 
        width: {lg:"210mm",xs:"170mm"},
      minHeight: "297mm", 
      mx: "auto", 
      bgcolor: "#fff", 
      fontFamily: font,
      boxShadow: "0 0 10px rgba(0,0,0,0.1)", 
      p: "15mm 20mm",
    }}>
      <Box sx={{width:"670px"}}>
        {/* Header Section */}
        <Grid container spacing={3} alignItems="center" sx={{ mb: 4 }}>
          <Grid item xs={2}>
            <Avatar
              src="https://via.placeholder.com/150"
              sx={{ width: 100, height: 100, border: "2px solid #eee" }}
            />
          </Grid>
          <Grid item xs={10}>
            <Typography variant="h4" sx={{ fontWeight: "900", color: "#222", mb: 0.5 }}>
              WAHANA PRIMA
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "gray", fontWeight: 500, mb: 1.5, letterSpacing: 1 }}>
              SPECIALIST GRAPHIC DESIGNER
            </Typography>
            <Stack direction="row" spacing={3} sx={{ "& p": { fontSize: "12px", display: "flex", alignItems: "center" } }}>
              <Typography><Phone sx={{ fontSize: 14, mr: 0.5, color }} /> +123-456-7890</Typography>
              <Typography><Email sx={{ fontSize: 14, mr: 0.5, color }} /> hello@reallygreatsite.com</Typography>
              <Typography><LocationOn sx={{ fontSize: 14, mr: 0.5, color }} /> 123 Anywhere St., Any City</Typography>
            </Stack>
          </Grid>
        </Grid>

        {/* Sections */}
        <SectionHeader title="About Me" />
        <Typography sx={{ fontSize, color: "#444", textAlign: "center", px: 4, mb: 5, lineHeight: 1.6 }}>
          Highly creative and detail-oriented Graphic Designer with over 6 years of experience in visual communication. 
        </Typography>

        <SectionHeader title="Education" />
        <Box sx={{ mb: 5 }}>
          {[
            { year: "2010 - 2014", school: "BORCELLE UNIVERSITY", degree: "BACHELOR OF DEVELOPER", desc: "Graduated with honors." },
            { year: "2014 - 2016", school: "BORCELLE UNIVERSITY", degree: "MASTER OF DESIGNER", desc: "Specialized in digital media." }
          ].map((edu, idx) => (
            <Grid container spacing={2} key={idx} sx={{ mb: 3 }}>
              <Grid item xs={3}>
                <Typography sx={{ fontWeight: "bold", color: "gray", fontSize }}>{edu.year}</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography sx={{ fontWeight: "bold", fontSize }}>{edu.school} | {edu.degree}</Typography>
                <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.5 }}>{edu.desc}</Typography>
              </Grid>
            </Grid>
          ))}
        </Box>

        <SectionHeader title="Work Experience" />
        <Box sx={{ mb: 5 }}>
          {[
            { year: "2014 - 2018", company: "WARDIERE COMPANY", role: "GRAPHIC SOFTWARE DESIGNER", desc: "Led the creative direction." },
            { year: "2018 - Present", company: "LARANA COMPANY", role: "WEB CONTENT MANAGER", desc: "Managing all digital assets." }
          ].map((work, idx) => (
            <Grid container spacing={2} key={idx} sx={{ mb: 3 }}>
              <Grid item xs={3}>
                <Typography sx={{ fontWeight: "bold", color: "gray", fontSize }}>{work.year}</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography sx={{ fontWeight: "bold", fontSize }}>{work.company} | {work.role}</Typography>
                <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.5 }}>{work.desc}</Typography>
              </Grid>
            </Grid>
          ))}
        </Box>

        <SectionHeader title="Skills" />
        <Grid container spacing={4} sx={{ textAlign: "left", px: 2 }}>
          {[
            ["Web Design", "Design Thinking", "Wireframe Creation"],
            ["Problem-Solving", "Computer Literacy", "Front End Coding"],
            ["Project Management Tools", "Strong Communication", "Leadership"]
          ].map((skillGroup, idx) => (
            <Grid item xs={4} key={idx}>
              <ul style={{ margin: 0, paddingLeft: "15px", fontSize }}>
                {skillGroup.map(skill => (
                  <li key={skill} style={{ marginBottom: "8px" }}>{skill}</li>
                ))}
              </ul>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Resume34;

export const resumeMeta = {
  hasPhoto: true, 
  columns: 1,
  colorOptions: [
    { value: '#4b2c4d', label: 'Purple' },
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#f44336', label: 'Red' }
  ]
};